export default __webpack_public_path__ + "static/media/7.d2cfca3d.png";